import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ofType, createEffect, Actions } from '@ngrx/effects';
import { tap } from 'rxjs/operators';

import { LocalStorageService } from '../local-storage/local-storage.service';
import { environment } from '../../../environments/environment';

import { authLogin, authLoginRequest, authLoginSuccess, authLogout } from './auth.actions';

export const AUTH_KEY = 'AUTH';

@Injectable()
export class AuthEffects {
  loginSuccess = createEffect(
    () =>
      this.actions$.pipe(
      ofType(authLoginSuccess),
      tap(() => {
        this.router.navigateByUrl('main/principal');  
      })
    ), { dispatch: false }
  );

  logout = createEffect(
    () =>
      this.actions$.pipe(
        ofType(authLogout),
        tap(() => {
          this.localStorageService.setItem(AUTH_KEY, {
            isAuthenticated: false
          });
          //this.router.navigate(['']);
          window.location.href = `${environment.backendUrl}/oidc/logout/`;
        })
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private localStorageService: LocalStorageService,
    private router: Router
  ) {}
}
